import { render, staticRenderFns } from "./GameOneToMany.vue?vue&type=template&id=168c028f&scoped=true&"
import script from "./GameOneToMany.vue?vue&type=script&lang=js&"
export * from "./GameOneToMany.vue?vue&type=script&lang=js&"
import style0 from "./GameOneToMany.vue?vue&type=style&index=0&id=168c028f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168c028f",
  null
  
)

export default component.exports